<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2">{{ 'MESSAGE_SENT' | translate }}</h1>
  <p class="mb-0">{{ 'WOULD_YOU_LOKE_TO_CONTINUE_THE_CHAT_OR_RETURN_TO_BROWSING' | translate }}</p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="showChat()">
    {{ 'CONTINUE_CHAT' | translate }}
  </button>
  <button
    type="button"
    class="btn rounded-5 fw-medium"
    (click)="close()"
    [class.btn-outline-dark]="!isBgDarkMode"
    [class.btn-outline-light]="isBgDarkMode"
  >
    {{ 'BROWSE' | translate }}
  </button>
</app-modal-footer>
